<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Clientes</p>
        </template>
        <b-row>                            
            <b-col cols="12" md="12">
                <div class="text-right">
                    <b-button variant="info" class="text-white" :to="{name: 'registerCliente'}">Nuevo Cliente</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="clientes">
                <template v-slot:cell(cliente)="data">
                    {{ data.item.cliente }}
                </template>
                <template v-slot:cell(documento)="data">
                    {{ data.item.documento }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="info" size="sm" v-b-tooltip.hover.right title="Ver" class="text-white mr-2" 
                    :to="{name: 'clientDetail', params:{ id: item.id}}">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                    <b-button variant="warning" size="sm" v-b-tooltip.hover.right title="Editar" class="text-white" 
                    :to="{name: 'updateCliente', params:{ id: item.id}}">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="clientes.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "ClientesTable",
    props: {
        clientes: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'cliente', label: 'Cliente', sortable: true},
                { key: 'tipo_documento', label: 'Tipo Documento', sortable: true},
                { key: 'documento', label: 'Documento', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ]
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-clientes');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);            
        }
    }
};

</script>
<style scoped>

</style>